'use client'

import { SnsPostXResponseVo } from '@schemas/non-auth'
import color from '@ui/style/color.theme'
import pxToRem from '@utils/pxToRem'
import { Box } from '@mui/joy'
import UISnsItem from './UISnsItem'

interface UISnsListProps {
	snsPost: SnsPostXResponseVo
	isLast?: boolean
}

const UISnsList = ({ snsPost, isLast }: UISnsListProps) => {
	return (
		<Box
			key={snsPost.snsId}
			sx={{
				padding: `${pxToRem(12)} 0`,
				borderBottom: isLast ? 'none' : `1px solid ${color.colGray3}`,
			}}
		>
			<UISnsItem
				snsPost={snsPost}
				hasChild={snsPost.childSnsPostList && snsPost.childSnsPostList.length > 0}
			/>
			{snsPost.childSnsPostList && snsPost.childSnsPostList.length > 0 && (
				<Box sx={{ marginTop: pxToRem(12) }}>
					{snsPost.childSnsPostList.map((childSnsPost) => (
						<UISnsItem key={childSnsPost.snsId} snsPost={childSnsPost} />
					))}
				</Box>
			)}
		</Box>
	)
}

export default UISnsList
